import { render, staticRenderFns } from "./TournamentHostManager.vue?vue&type=template&id=643ee6b4&"
import script from "./TournamentHostManager.vue?vue&type=script&lang=js&"
export * from "./TournamentHostManager.vue?vue&type=script&lang=js&"
import style0 from "./TournamentHostManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('643ee6b4')) {
      api.createRecord('643ee6b4', component.options)
    } else {
      api.reload('643ee6b4', component.options)
    }
    module.hot.accept("./TournamentHostManager.vue?vue&type=template&id=643ee6b4&", function () {
      api.rerender('643ee6b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tournament/TournamentHostManager.vue"
export default component.exports